export default __webpack_public_path__ + "4d192b601516d24f85344e65230e1ac1.svg";